import * as React from 'react';

import * as styles from './styles.css';

export function ContentWrapper({ children }: React.PropsWithChildren<{}>) {
  return <div className={styles['container']}>{children}</div>;
}
